import React from 'react';
import styled from 'styled-components';

import colors from '@front/common/src/utils/colors';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import { getGradient } from '@front/web-ui/src/styles/gradient';

const StyledSlot = styled.div<{
  $isPrimary: boolean;
}>`
  width: 45px;
  padding: 3px 8px;
  margin: 0 5px 5px 0;
  background: ${({ $isPrimary }) => ($isPrimary ? getGradient() : colors.ink20)};
  border-radius: 2px;
  text-align: center;
`;

type SlotProps = {
  className?: string;
  text: string;
  isPrimary: boolean;
  label: string;
};

const Slot = ({ text, isPrimary, label, className }: SlotProps) => (
  <StyledSlot className={className} $isPrimary={isPrimary} aria-label={label}>
    <Text.SMMedium centered color={isPrimary ? colors.white100 : colors.ink100}>
      {text}
    </Text.SMMedium>
  </StyledSlot>
);

export default Slot;
